import { useEffect, useMemo } from "react";
import "./App.css";
import { useSelector, useDispatch } from "react-redux";
import { checkAuth } from "../store/reducers/authReducer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UnAuthSwitch from "../navigation/UnAuthSwitch";
import UserSwitch from "../navigation/UserSwitch";
import FilledLoading from "../components/common/loader/FilledLoading";
import AdminSwitc from "../navigation/AdminSwitc";
import ProducerSwitch from "../navigation/ProducerSwitch";
import EfratSwitch from "../navigation/EfratSwitch";
import { AccessibilityProvider } from "../contexts/AccessibilityContext";
import AccessibilityPanel from "../components/common/AccessibilityPanel";

function App() {
  const { user, authenticated, authLoading } = useSelector(
    (state) => state.authReducer,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) dispatch(checkAuth());
  }, [authenticated]);

  let view = useMemo(() => {
    if (
      authenticated &&
      user &&
      !authLoading &&
      (user.role === 1 || user.role === 5 || user.role === 6)
    )
      return <UserSwitch />;
    else if (authenticated && user && !authLoading && user.role === 2)
      return <AdminSwitc />;
    else if (authenticated && user && !authLoading && user.role === 3)
      return <ProducerSwitch />;
    else if (authenticated && user && !authLoading && user.role === 4)
      return <EfratSwitch />;
    else return <UnAuthSwitch />;
  }, [authenticated]);

  return (
    <AccessibilityProvider>
      <div className="App animate__animated animate__fadeIn">
        {view}
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
          theme="light"
        />
        {authLoading && user?.isTal == false && <FilledLoading />}
        <AccessibilityPanel />
      </div>
    </AccessibilityProvider>
  );
}

export default App;
